
export enum WesternIslesRecordType  {           
        Monument = "mon",     
        Event = "event", 
        Source = "source",
        Designation = "desig"
}  

export enum WesternIslesRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    DesignedLandscape = "DLN",
    ScheduledMonument = "SAM",
    HistoricBattlefield = "IHB",
    HistoricMarineProtectedArea = "HMPA"
}  

